import { DropdownMenu, type MenuItem } from '@ics-portal/guardian';
import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';
import s from '../TabbedInfoCard.module.scss';

interface InfoCardWrapperProps
    extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
    title: string | ReactNode;
    actions?: MenuItem[] | null;
    className?: string;
    children?: ReactNode;
    headerContent?: ReactNode;
}

interface InfoCardHeaderProps {
    title: string | ReactNode;
    actions?: MenuItem[] | null;
    children?: ReactNode;
}

function InfoCardHeader({
    actions,
    title,
    children,
}: InfoCardHeaderProps): ReactNode {
    return (
        <div className={s.infoCardHeader}>
            {title ? <h2 className="p50-underline">{title}</h2> : null}
            {children}
            {actions?.length ? (
                <DropdownMenu iconSize="normal" actions={actions} />
            ) : null}
        </div>
    );
}

export default function InfoCardWrapper({
    title,
    headerContent,
    actions,
    className = '',
    children,
    ...rest
}: InfoCardWrapperProps): ReactNode {
    const calcClassName = clsx(className, s.infoCardWrapper, 'infoCardWrapper');

    return (
        <div className={calcClassName} {...rest}>
            <InfoCardHeader title={title} actions={actions}>
                {headerContent}
            </InfoCardHeader>
            {children}
        </div>
    );
}
